import { render, staticRenderFns } from "./CliL_List.vue?vue&type=template&id=50755364"
import script from "./CliL_List.vue?vue&type=script&lang=js"
export * from "./CliL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports